var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule2IconRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    sodipodidocname: "module2_icon_red.svg",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs90"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview88",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapezoom: 0.90774833,
    inkscapecx: -844.94785,
    inkscapecy: 339.30109,
    "inkscapewindow-width": 3440,
    "inkscapewindow-height": 1302,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent--layer": "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1904",
    inkscapelabel: "check",
    transform: "translate(16.215948,74.506118)",
    style: {
      fill: "#000000",
      stroke: "#ff0000",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.5163,8.93451 11.0597,14.7023 8.0959,11.8984",
    stroke: "#000000",
    strokeWidth: 2,
    id: "path274",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeOpacity: 1
    },
    transform: "matrix(6.2026611,0,0,6.2026611,336.61383,-11.366694)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12,21 c 4.9706,0 9,-4.0294 9,-9 0,-4.97056 -4.0294,-9 -9,-9 -4.97056,0 -9,4.02944 -9,9 0,4.9706 4.02944,9 9,9 z",
    stroke: "#000000",
    strokeWidth: 2,
    id: "path276",
    style: {
      fill: "none",
      stroke: "#ff0000",
      strokeOpacity: 1
    },
    transform: "matrix(6.2026611,0,0,6.2026611,336.61383,-11.366694)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2077",
    transform: "matrix(5.9989689,0,0,5.9989689,-552.11732,-211.91299)",
    inkscapelabel: "laptop",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "m 11.066068,24.592075 c -1.738983,0 -3.1670026,1.416928 -3.1670026,3.159918 V 46.720044 65.691012 68.85093 L -3.8839893e-7,78.336102 C -3.8839893e-7,80.949082 2.1219232,83.074 4.7378972,83.074 H 80.610102 c 2.61298,0 4.737898,-2.125918 4.737898,-4.737898 l -7.898024,-9.48413 V 65.692054 46.720044 30.377027 c -0.04879,0.0793 -0.09425,0.160971 -0.149817,0.235666 -0.299728,0.402891 -0.665071,0.741209 -1.038512,1.073309 -0.36902,0.324184 -0.778499,0.59767 -1.200623,0.847021 -0.229321,0.13791 -0.471583,0.250861 -0.718249,0.353602 -0.16668,0.07517 -0.335969,0.14478 -0.50717,0.208994 -0.141673,0.05247 -0.287215,0.09316 -0.435492,0.121688 l -0.06564,0.01042 c -0.118808,0.01871 -0.229376,0.0254 -0.33339,0.02375 v 30.010574 c 0,1.52499 -1.242036,2.759016 -2.759016,2.759016 H 15.105929 c -1.51399,0 -2.75589,-1.245026 -2.75589,-2.759016 V 30.193037 c 0,-1.52498 1.2419,-2.759016 2.75589,-2.759016 h 47.151645 c -0.03771,-0.100305 -0.07144,-0.202059 -0.100226,-0.305677 -0.07603,-0.289496 -0.128914,-0.585099 -0.146483,-0.884319 -0.0159,-0.290704 -0.01071,-0.580917 0.02875,-0.869108 -0.0128,-0.119186 0.007,-0.243346 0.06189,-0.363395 0.02758,-0.141257 0.05821,-0.281939 0.09981,-0.419447 z m 20.989857,50.851863 h 21.233024 l 2.41604,2.895081 H 29.644052 Z m 4.301989,4.473061 h 12.644048 c 0.437,0 0.79097,0.35101 0.79097,0.78701 -0.008,0.445 -0.35497,0.794928 -0.79097,0.794928 H 36.357914 c -0.43699,0 -0.790969,-0.353928 -0.790969,-0.794928 0,-0.437 0.353979,-0.78701 0.790969,-0.78701 z",
    transform: "translate(92.03537,33.665402)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2075",
    transform: "matrix(5.9989689,0,0,5.9989689,1.8731333e-6,-9.955287)",
    inkscapelabel: "wifi",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.77433
    },
    d: "m 44.22498,7.8708704 c 4.988235,0 9.768176,2.1286339 13.11638,5.8307066 l 2.056621,-1.856844 C 55.52633,7.558041 49.992191,5.0995424 44.222657,5.0995424 c -5.772632,0 -11.30135,2.4577242 -15.172227,6.7451906 l 2.056621,1.856844 C 34.459126,9.994084 39.239841,7.8708704 44.22498,7.8708704 Z",
    id: "path2069"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.77433
    },
    d: "m 55.53717,15.328445 c -2.885154,-3.194887 -7.008463,-5.026952 -11.31219,-5.026952 -4.300631,0 -8.427037,1.832065 -11.314514,5.026952 l 2.056621,1.856844 c 2.36403,-2.613365 5.739336,-4.112468 9.258667,-4.112468 3.522428,0 6.894637,1.499103 9.253247,4.112468 z",
    id: "path2071"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.77433
    },
    d: "m 37.025257,19.042133 2.056621,1.856844 c 2.621882,-2.906836 7.665095,-2.906836 10.28388,0 l 2.056621,-1.856844 c -1.837485,-2.034166 -4.458593,-3.197984 -7.199722,-3.197984 -2.741129,0 -5.359914,1.163818 -7.1974,3.197984 z",
    id: "path2073"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04095563,0,0,-0.04095563,112.48245,458.8474)",
    fill: "#ff0000",
    stroke: "none",
    id: "g8692",
    inkscapelabel: "icon",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3115,6899 c -423,-29 -828,-146 -1079,-313 -113,-75 -214,-184 -262,-282 l -39,-78 V 4641 3055 l 23,-56 c 107,-265 452,-474 947,-574 528,-107 1124,-78 1588,76 324,108 545,266 640,457 l 42,85 v 1591 1591 l -38,79 c -189,397 -970,652 -1822,595 z m 460,-139 c 220,-12 585,-75 585,-101 0,-4 -39,-27 -87,-50 -49,-23 -102,-50 -119,-60 l -31,-19 18,-77 c 11,-43 25,-111 33,-151 l 14,-74 -45,-19 c -24,-10 -121,-44 -216,-74 -95,-30 -178,-59 -185,-64 -10,-6 -4,-44 32,-182 42,-163 44,-175 28,-190 -9,-9 -89,-61 -178,-116 l -161,-100 -114,9 c -634,47 -1118,246 -1250,513 -28,57 -31,72 -27,132 5,86 33,145 105,224 165,177 515,318 938,378 83,11 168,22 190,24 86,8 308,6 470,-3 z m 902,-216 c 156,-82 269,-177 328,-278 40,-68 46,-172 16,-241 -109,-246 -539,-453 -1066,-514 -150,-17 -205,-21 -205,-17 0,2 50,36 110,75 85,55 110,76 110,93 0,12 -16,82 -36,156 -19,73 -34,141 -32,149 2,10 76,40 217,89 118,41 219,78 224,83 9,9 -27,187 -60,304 -4,14 21,30 129,82 73,35 143,64 155,64 12,1 62,-20 110,-45 z M 2089,5636 c 188,-107 448,-196 711,-241 91,-16 355,-44 413,-45 27,0 33,-11 128,-206 54,-114 99,-214 99,-223 0,-19 -50,-79 -205,-247 -60,-66 -122,-133 -138,-151 -22,-23 -28,-38 -24,-55 4,-13 65,-119 136,-236 l 131,-213 -111,-197 c -61,-108 -125,-220 -141,-249 l -29,-52 152,-163 c 83,-90 154,-164 158,-166 4,-1 26,18 50,42 l 44,45 -28,33 c -15,18 -68,77 -117,131 -54,59 -88,103 -85,112 3,7 51,92 105,187 55,95 112,197 127,227 l 27,54 -23,41 c -12,23 -72,121 -131,219 l -109,178 34,42 c 67,82 259,282 273,285 19,5 317,-280 358,-343 19,-27 79,-133 136,-235 56,-102 107,-191 115,-198 10,-11 21,-9 64,12 28,15 51,31 51,37 0,6 -47,97 -105,203 -58,106 -105,199 -105,207 0,17 264,143 284,136 7,-3 46,-43 87,-89 40,-46 78,-84 85,-86 14,-4 94,65 94,80 0,10 -227,268 -236,268 -2,0 -95,-43 -207,-95 l -202,-95 -70,68 c -38,37 -119,114 -178,172 l -109,105 -99,199 c -55,109 -98,201 -95,204 3,3 56,9 118,14 405,29 684,91 954,210 112,49 250,136 318,198 l 44,41 7,-158 c 5,-87 5,-702 1,-1368 l -7,-1210 -31,-58 c -121,-226 -502,-406 -1023,-484 -151,-22 -651,-25 -815,-5 -339,42 -658,145 -856,275 -87,57 -183,156 -216,222 l -25,50 -7,1070 c -3,589 -3,1204 0,1366 l 7,296 70,-58 c 39,-33 104,-79 146,-103 z",
    id: "path8654",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2860,6415 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path8656",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3500,6415 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path8658",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2364,6163 c 3,-21 6,-53 6,-70 v -33 h 60 c 70,0 80,11 80,89 v 51 h -76 -77 z",
    id: "path8660",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3010,5840 v -70 h 43 c 82,0 87,4 87,76 v 64 h -65 -65 z",
    id: "path8662",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4424,6307 c -3,-13 -4,-41 -2,-63 l 3,-39 68,-3 67,-3 v 66 65 h -65 c -59,0 -65,-2 -71,-23 z",
    id: "path8664",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4070,5840 v -70 h 65 65 v 70 70 h -65 -65 z",
    id: "path8666",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4490,5200 v -70 h 65 65 v 70 70 h -65 -65 z",
    id: "path8668",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2150,5161 c 0,-21 3,-53 6,-70 6,-31 7,-31 70,-31 h 64 v 70 70 h -70 -70 z",
    id: "path8670",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2860,5065 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path8672",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3930,5065 v -65 h 65 65 v 65 65 h -65 -65 z",
    id: "path8674",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2510,4565 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path8676",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2800,3990 v -70 h 34 c 18,0 48,3 65,6 31,6 31,7 31,70 v 64 h -65 -65 z",
    id: "path8678",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2090,3925 v -65 h 65 65 v 65 65 h -65 -65 z",
    id: "path8680",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3720,3716 c 0,-69 6,-76 72,-76 52,0 58,7 58,76 v 64 h -65 -65 z",
    id: "path8682",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4350,3425 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path8684",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2510,3350 v -70 h 70 70 v 70 70 h -70 -70 z",
    id: "path8686",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2860,2850 v -70 h 70 70 v 70 70 h -70 -70 z",
    id: "path8688",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3780,2850 v -70 h 70 70 v 70 70 h -70 -70 z",
    id: "path8690",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.03049679,0,0,-0.03049679,226.27085,410.23838)",
    fill: "#ff0000",
    stroke: "none",
    id: "g2547",
    inkscapelabel: "icon2",
    style: {
      display: "inline",
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2509",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "m 3114.9888,6899.0261 c -87.7794,-6.0181 -165.6684,-30.2304 -250.6821,-43.4882 -7.006,-26.9874 -21.1918,-56.4777 -44.3899,-87.2223 -14.8734,-19.7106 -31.5119,-38.1186 -45.4966,-58.4897 -1.6675,-2.662 -3.2227,-5.4116 -4.8366,-8.1157 51.7042,10.2891 91.0318,29.5906 145.3842,37.2991 82.9998,10.9998 168.0213,22.0189 190.02,24.0189 85.9998,8 308.0113,5.9669 470.0085,-3.0331 219.9968,-12 584.9796,-74.9943 584.9796,-100.9943 0,-4 -38.9779,-27.0067 -86.9764,-50.0052 -49,-23 -102.0291,-50.0065 -119.0289,-60.0063 l -30.9869,-18.9775 17.9937,-77.0163 c 11,-42.9985 24.9966,-110.9995 32.9953,-150.9995 l 14.0178,-73.9832 -45.0047,-19.0183 c -24,-9.9987 -121.0078,-43.9834 -216.0063,-73.9832 -94.9985,-29.9987 -177.9785,-58.9822 -184.9785,-63.9822 -9.9987,-6 -4.0281,-44.0303 31.9706,-182.0273 41.9998,-162.9985 43.9947,-174.9791 27.9947,-189.9791 -9,-8.9998 -88.971,-60.9958 -177.9695,-115.9958 l -161.0006,-100.0105 -114.0284,8.9764 c -126.599,9.384 -241.763,29.0441 -354.7914,49.8823 50.9875,-53.1424 56.1052,-111.1457 30.7819,-149.565 103.8454,-16.2617 333.5394,-41.3599 388.0326,-42.2995 27,0 33.0068,-11.0083 128.0053,-206.0053 53.9987,-113.9985 98.9858,-214.0153 98.9858,-223.0153 0,-18.9985 -49.9822,-78.9947 -204.9805,-246.9932 -59.9987,-65.9985 -122.0064,-132.9995 -138.0064,-150.9995 -22,-22.9985 -28.0189,-38.0058 -24.0189,-55.0058 4,-12.9985 64.9994,-118.9689 135.9979,-235.9674 l 130.9974,-213.0142 -110.9953,-196.988 c -60.9985,-107.9985 -124.9997,-220.0016 -140.9984,-249.0016 l -28.9785,-52.0137 151.9832,-163.0089 c 82.9985,-89.9985 154.0085,-164.0011 158.0085,-166.0011 4,-1 26.0054,18.0126 50.0052,42.0126 l 43.9801,45.0048 -27.9948,32.9952 c -15,18 -67.981,76.9989 -116.9795,130.9974 -54,59 -88.009,103.02 -85.009,112.02 3,7 51.0113,91.9884 105.0111,186.9869 54.9985,94.9985 111.9819,196.9911 126.9806,226.9911 l 27.011,54.0221 -22.9942,40.9879 c -12,23 -71.9989,121 -130.9974,218.9985 l -109.0279,178.0105 34.02,41.9716 c 66.9985,81.9987 258.9796,282.03 272.9796,285.03 18.9998,5 317.0309,-280.0279 358.0294,-343.0279 19,-26.9998 78.9993,-132.9852 135.998,-234.9837 55.9998,-101.9985 106.9724,-191.0127 114.9711,-198.0127 10,-11 21.0231,-8.9905 64.0231,12.0095 27.9987,15 50.989,31.0121 50.989,37.0121 0,6 -47.0124,96.9737 -105.0111,202.9722 -57.9985,105.9985 -104.97,199.0313 -104.97,207.03 0,16.9998 263.9656,142.9979 283.9643,135.9979 7,-3 46.0175,-43.0258 87.0173,-89.0258 40,-45.9998 78.0103,-83.9926 85.009,-85.9926 14,-4 93.9853,65.0084 93.9853,80.0084 0,10 -227.0085,267.979 -236.0085,267.979 -2,0 -94.9905,-42.9705 -206.989,-94.969 l -201.9884,-95.01 -70.0074,67.9989 c -38,37 -119.0107,113.9854 -178.0105,171.9854 l -108.9869,105.011 -98.9859,198.9964 c -54.9985,108.9972 -98.0098,200.997 -95.01,203.9968 3,3 56.0056,9.0179 118.0043,14.0179 404.994,29 683.9983,90.9828 953.9938,209.9811 111.9985,49 249.9845,136.0127 317.9843,198.0127 l 44.021,40.9879 6.968,-158.0084 c 4.9987,-87 5.0247,-701.9822 1.0247,-1367.9719 l -7.009,-1210.0044 -30.9868,-57.9979 c -120.9972,-225.997 -502.0252,-406.0278 -1023.0175,-484.0263 -150.9972,-22 -651.0055,-25.0004 -815.0038,-5.0006 -46.2608,5.7316 -88.4485,17.5776 -131.2434,28.5276 -0.5998,-10.1525 -1.2659,-20.2996 -1.8854,-30.454 -2.4625,-40.3774 -11.6962,-73.1307 -25.1256,-98.494 500.9709,-83.8442 1047.528,-60.503 1481.2625,83.4514 323.9953,107.9985 544.9868,265.9761 639.9853,456.9744 l 42.0127,85.0089 v 1590.9871 1591.0281 l -37.9958,78.9838 c -188.9972,396.994 -970.0084,652.0201 -1821.9951,595.0216 z m 1252.017,-310.0326 c 12,1 61.9708,-19.9638 109.9706,-44.9638 155.9972,-81.9985 269.0277,-177.0225 328.0264,-278.021 39.9998,-67.9987 45.9852,-172.0105 15.9852,-241.009 -108.9983,-245.997 -539.0213,-452.9887 -1066.0138,-513.9885 -149.9983,-16.9987 -204.9806,-21.01 -204.9806,-17.01 0,2 50.0118,36.0079 110.0116,75.0079 84.9985,54.9985 109.9706,76.0029 109.9706,93.0016 0,11.9998 -15.9887,82.0002 -35.9874,156 -19,72.9985 -34.0116,140.9911 -32.0116,148.9911 2,10 75.9916,40.0272 216.9901,89.0257 117.9972,41 218.999,78.0006 223.999,83.0006 9,9 -26.9654,186.9679 -59.9654,303.9664 -4,14 20.9905,30.0183 128.989,82.0168 72.9987,35 143.0165,63.9822 155.0163,63.9822 z M 2405.7338,5500.1084 c -0.1233,-0.1775 -0.2455,-0.3554 -0.3688,-0.5329 9.0177,-3.3272 15.9414,-7.8157 25.3305,-10.9437 -8.2425,3.993 -16.6832,7.5606 -24.9617,11.4766 z M 1734.9665,3826.0387 v -0.2459 l 0.041,-0.041 c -0.01,0.096 -0.032,0.1909 -0.041,0.2869 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2860,6415 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path2511",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3500,6415 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path2513",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2515",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    },
    d: "m 2464.4423,6117.254 c -1.1873,-2.3081 -2.6898,-5.2452 -2.8691,-5.7383 -0.1673,-0.4535 0.9722,-0.746 1.3526,-0.4509 1.1476,0.8922 1.1788,3.9152 2.5822,3.525 2.2435,-0.6214 -1.0955,-8.9446 1.4756,-1.4756 -0.4548,0.9004 -0.9106,1.8005 -1.4346,2.7052 -0.3332,0.4974 -0.7434,0.9529 -1.1067,1.4346 z m 4.2628,-7.8287 c 1.7946,-5.3032 3.9902,-12.0173 2.7052,-7.7057 -0.8122,2.7248 -1.6835,5.252 -2.7052,7.7057 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3010,5840 v -70 h 43 c 82,0 87,4 87,76 v 64 h -65 -65 z",
    id: "path2517",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4424,6307 c -3,-13 -4,-41 -2,-63 l 3,-39 68,-3 67,-3 v 66 65 h -65 c -59,0 -65,-2 -71,-23 z",
    id: "path2519",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4070,5840 v -70 h 65 65 v 70 70 h -65 -65 z",
    id: "path2521",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4490,5200 v -70 h 65 65 v 70 70 h -65 -65 z",
    id: "path2523",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2860,5065 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path2527",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3930,5065 v -65 h 65 65 v 65 65 h -65 -65 z",
    id: "path2529",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2800,3990 v -70 h 34 c 18,0 48,3 65,6 31,6 31,7 31,70 v 64 h -65 -65 z",
    id: "path2533",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3720,3716 c 0,-69 6,-76 72,-76 52,0 58,7 58,76 v 64 h -65 -65 z",
    id: "path2537",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4350,3425 v -65 h 70 70 v 65 65 h -70 -70 z",
    id: "path2539",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2860,2850 v -70 h 70 70 v 70 70 h -70 -70 z",
    id: "path2543",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3780,2850 v -70 h 70 70 v 70 70 h -70 -70 z",
    id: "path2545",
    style: {
      fill: "#ff0000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04099967,0,0,-0.04099967,240.50508,448.96449)",
    fill: "#ff0000",
    stroke: "none",
    id: "g2596",
    inkscapelabel: "icon3",
    style: {
      display: "inline",
      fill: "#ff0000",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2558",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    },
    d: "m -1862.7344,5808.9019 c -245.8895,-16.8577 -481.332,-84.8686 -627.2382,-181.9454 -65.6865,-43.5977 -124.4086,-106.9438 -152.3111,-163.9107 l -22.6663,-45.3736 v -921.3675 -921.9413 l 13.4031,-32.5444 c 62.1986,-154.0444 262.7251,-275.5114 550.4677,-333.6417 254.9762,-51.6709 528.7168,-36.3621 771.5976,17.4199 -14.2933,22.2158 -18.0862,49.6176 -9.7141,77.3032 -47.4789,-11.3351 -81.277,-29.8869 -134.0715,-37.7909 -87.776,-12.788 -378.4465,-14.5362 -473.7794,-2.9101 -197.0601,24.4147 -382.4961,84.3253 -497.5933,159.8939 -50.5733,33.1336 -106.363,90.6646 -125.546,129.0299 l -14.5507,29.0605 -4.0578,621.9917 c -1.7439,342.3843 -1.7439,699.8887 0,794.059 l 4.0578,172.0672 40.701,-33.692 c 22.6708,-19.183 60.4713,-45.9322 84.886,-59.8834 109.2841,-62.1987 260.3994,-113.9381 413.2812,-140.0967 52.8978,-9.3009 206.3917,-25.569 240.1072,-26.1503 15.6952,0 19.1694,-6.4135 74.3931,-119.7667 31.3897,-66.2678 57.547,-124.4131 57.547,-129.6448 0,-11.0447 -29.0507,-45.9226 -119.1519,-143.5807 -34.8775,-38.3652 -70.9124,-77.2917 -80.2133,-87.7551 -12.7886,-13.37 -16.3021,-22.0884 -13.9769,-31.9706 2.3252,-7.5569 37.7932,-69.1748 79.0657,-137.1865 l 76.1555,-123.8246 -64.5149,-114.5202 c -35.4595,-62.7799 -72.675,-127.8712 -81.9759,-144.7283 l -16.846,-30.2491 88.329,-94.7231 c 48.2474,-52.3172 89.5287,-95.364 91.8539,-96.5266 2.3252,-0.5813 15.1092,10.4776 29.0604,24.4288 l 25.5765,26.1503 -16.2722,19.1824 c -8.7196,10.4634 -39.5152,44.7659 -67.999,76.1555 -31.3904,34.2969 -51.1753,59.8571 -49.4314,65.0888 1.7439,4.0691 29.6817,53.5179 61.072,108.741 31.9717,55.223 65.0997,114.501 73.8192,131.9401 l 15.6984,31.3968 -13.403,23.8139 c -6.9756,13.37 -41.8177,70.3415 -76.1146,127.3085 l -63.3673,103.4945 19.7561,24.3878 c 38.9473,47.6668 150.5671,163.9293 158.7053,165.6732 11.0448,2.9065 184.2629,-162.7439 208.0956,-199.3652 11.0447,-15.6952 45.9322,-77.32 79.0657,-136.6128 17.4105,-31.7113 23.3729,-40.3131 35.7415,-61.5638 -6.5593,64.1139 -14.1247,128.1199 -20.6989,192.2333 -0.683,5.9492 -1.1936,11.9188 -1.8445,17.8707 -0.037,0.1892 -1.5985,3.0342 -1.5985,3.1561 0,0.073 1.2129,0.4937 1.2297,0.5738 -3.2824,30.3327 -6.1255,60.709 -8.6075,91.1162 l -47.8329,-22.5024 -40.701,39.5534 c -22.0895,21.5075 -69.1573,66.254 -103.4535,99.9695 l -63.3674,61.031 -57.547,115.6679 c -31.9716,63.362 -56.9546,116.8752 -55.2107,118.6191 1.7439,1.7439 32.532,5.2091 68.5728,8.1156 111.066,7.9529 188.4619,30.5716 272.8156,50.1282 -3.237,19.2135 -4.3431,40.7658 -2.7052,64.6789 0.2404,3.5183 0.3054,4.589 0.3689,5.5744 -44.5236,-9.932 -86.6182,-22.3519 -135.0143,-27.9538 -87.1946,-9.8815 -119.1928,-12.2032 -119.1928,-9.878 0,1.1626 29.0637,20.9403 63.9411,43.6111 49.4107,31.9716 63.9412,44.181 63.9412,54.0631 0,6.9757 -9.2779,47.6495 -20.9039,90.6652 -11.0441,42.4351 -19.7711,81.9571 -18.6085,86.6075 1.1626,5.813 44.1563,23.243 126.1199,51.7268 48.0387,16.6916 68.6256,24.985 91.1981,33.815 9.9234,16.554 21.5229,29.7123 34.1019,39.5124 -1.4622,25.5263 -13.0641,89.4841 -29.1424,147.5975 h -0.041 c -26.485,19.6052 -40.1566,50.874 -36.4792,85.4598 -14.8427,-7.4345 -33.6581,-16.4981 -39.2664,-19.7972 l -18.0347,-11.0257 10.4519,-44.7588 c 6.3943,-24.996 14.5319,-64.5441 19.1823,-87.7962 l 8.1566,-42.9963 -26.1503,-11.0667 c -13.9506,-5.8131 -70.3639,-25.5573 -125.5869,-42.9964 -55.2238,-17.4384 -103.4423,-34.3105 -107.5114,-37.217 -5.813,-3.4878 -2.3183,-25.5708 18.6086,-105.7898 24.414,-94.7516 25.573,-101.7429 16.2722,-110.4625 -5.2318,-5.2317 -51.7592,-35.4534 -103.4945,-67.4251 l -93.5755,-58.1209 -66.2774,5.2465 c -368.5437,27.3212 -649.9027,142.9807 -726.6339,298.1871 -16.2764,33.1342 -18.0237,41.8512 -15.6984,76.7294 2.9065,49.9913 19.1773,84.2964 61.0311,130.2186 95.9142,102.8899 299.3728,184.8581 545.2623,219.7363 48.2474,6.3943 97.6737,12.7733 110.4624,13.9359 49.992,4.6504 179.0552,3.5102 273.2255,-1.7215 105.1325,-5.7345 225.192,-30.8927 279.5376,-48.2838 12.3664,19.5246 30.6093,38.7867 55.4567,56.4404 -177.0979,52.6565 -376.1993,87.7633 -602.3995,72.6306 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2010.9709,5527.5541 v -37.7847 h 40.6911 40.6912 v 37.7847 37.7846 h -40.6912 -40.6911 z",
    id: "path2560",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1638.9374,5527.5541 v -37.7847 h 40.6912 40.6912 v 37.7847 37.7846 h -40.6912 -40.6912 z",
    id: "path2562",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2299.2969,5381.0658 c 1.7439,-12.2073 3.4878,-30.809 3.4878,-40.6911 v -19.183 h 34.8781 c 40.6912,0 46.5042,6.3943 46.5042,51.7359 v 29.6464 h -44.179 -44.7603 z",
    id: "path2564",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1923.7756,5193.3052 v -40.6912 h 24.996 c 47.6668,0 50.5733,2.3252 50.5733,44.179 v 37.2033 h -37.7846 -37.7847 z",
    id: "path2566",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2423.6957,4798.6008 c 0,-12.2073 1.7439,-30.809 3.4878,-40.6912 3.4879,-18.0203 4.0692,-18.0203 40.6912,-18.0203 h 37.2034 v 40.6911 40.6912 h -40.6912 -40.6912 z",
    id: "path2574",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2010.9709,4742.7958 v -37.7847 h 40.6911 40.6912 v 37.7847 37.7846 h -40.6912 -40.6911 z",
    id: "path2576",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2578",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    },
    d: "m -1388.996,4780.5969 v -37.7909 -37.7908 h 37.7908 24.2649 c 3.5774,14.1156 8.114,23.7456 13.526,29.3473 v 8.4435 37.7909 h -37.7909 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2214.4268,4452.1446 v -37.7847 h 40.6912 40.6912 v 37.7847 37.7846 h -40.6912 -40.6912 z",
    id: "path2580",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2045.8491,4117.8957 v -40.6912 h 19.7643 c 10.4634,0 27.9025,1.7439 37.7847,3.4878 18.0203,3.4878 18.0203,4.0691 18.0203,40.6912 v 37.2033 h -37.7846 -37.7847 z",
    id: "path2582",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2458.5738,4080.111 v -37.7847 h 37.7846 37.7847 v 37.7847 37.7847 h -37.7847 -37.7846 z",
    id: "path2584",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1511.0508,3958.6188 c 0,-40.1099 3.4878,-44.179 41.8537,-44.179 30.2278,0 33.7156,4.0691 33.7156,44.179 v 37.2033 h -37.7847 -37.7846 z",
    id: "path2586",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2214.4268,3745.8621 v -40.6912 h 40.6912 40.6912 v 40.6912 40.6912 h -40.6912 -40.6912 z",
    id: "path2590",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2010.9709,3455.2109 v -40.6912 h 40.6911 40.6912 v 40.6912 40.6911 h -40.6912 -40.6911 z",
    id: "path2592",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -1476.1727,3455.2109 v -40.6912 h 40.6912 40.6911 v 40.6912 40.6911 h -40.6911 -40.6912 z",
    id: "path2594",
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.581302
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule2IconRed);
export default __webpack_public_path__ + "static/media/module2_icon_red.d627d388.svg";
export { ForwardRef as ReactComponent };